import Content from '../components/Content';

const Wip = ({ bookStore, userStore }) => {
  return (
    <Content title='Cadastro de Livros' userStore={userStore}>
      WIP!
    </Content>
  );
};
export default Wip;
